class ContentCardsGrid extends HTMLElement {
  constructor() {
    super();
    this.cardsGrid = this.querySelector('.content-cards-grid__cards');
    this.loadMoreBtn = this.querySelector('.content-cards-grid__load-more-button');
  }

  connectedCallback() {
    if (!this.cardsGrid || !this.loadMoreBtn) return;

    this.loadMoreBtn.addEventListener('click', () => {
      const hiddenCards = this.cardsGrid.querySelectorAll('[hidden]');
      hiddenCards.forEach(card => card.removeAttribute('hidden'));
      this.loadMoreBtn.setAttribute('hidden', '');
    });
  }
}

customElements.define('content-cards-grid', ContentCardsGrid);
